import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./polyfills/arrayToSpliced";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./libs/react-query/queryClient";
import { Toaster } from "./components/ui/sonner";
import CommonImg from "./components/Common/Img";
import ToastSuccessIcon from "./assets/images/toast-success-icon.svg";
import { GlobalLoading } from "@/components/GlobalLoading";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{ v7_startTransition: false, v7_relativeSplatPath: false }}
      >
        <GlobalLoading />
        <App />
        <Toaster
          icons={{
            success: <CommonImg src={ToastSuccessIcon} alt="success" />,
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
